/*
 * Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Type } from '@angular/core';
import { OutsideClick } from './outside-click';

export * from './outside-click';

export const OUSTIDE_CLICK_DIRECTIVES: Type<any>[] = [OutsideClick];
